import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_detailNoticeList} from "function/FnBodySetting";
import { useFetch } from "react-async";

@observer
class NoticeListItemView extends Component {

    render() {
        const { rootStore, obj } = this.props;
        const getNoticeId = rootStore.settingStore.getNoticeId;
        
        return (
            <li key={obj.id} className={obj.id===getNoticeId?'list on '+ obj.detailType : 'list'}
                    onClick={ (event) => {rootStore.settingStore.setNoticeId(obj.id); fn_detailNoticeList(rootStore)
                        document.getElementById("notiScroll").scrollTo(0, 0); }} >
                <p className="tit">
                    <span className={"box " + (obj.detailType === "N" ? "gray" : obj.detailType === "I" ? "blue" : "red")}>
                        {obj.detailType === "N" ? "공지" : obj.detailType === "I" ? "안내" : "긴급"}
                    </span>
                    {obj.title}
                </p>
                <p className="txt">
                    <span className="date">{obj.insDt}</span>
                    <span className={(obj.isNew === "Y"? "ico" : "")}>{(obj.isNew === "Y"? "NEW" : "")}</span>
                </p>
            </li>
        );
    }
}

export default NoticeListItemView;